import {LiveCasinoGridItemTitleMrGreenBox} from "./live-casino-grid-item-title.mrgreen.box";

export const LiveCasinoGridItemTitleMrGreenCisBox = LiveCasinoGridItemTitleMrGreenBox;
